import { CuratedTripSection, FullTrip } from 'tripPlanner/types/common'
import { NoteItem, TripItem } from 'tripPlanner/types/tripItem'

/**
 * Group the trip items into day sections.
 * `tripItems` is passed in separately to `trip` so we can
 * use the sorting from the trip summary API call.
 */
export function groupCuratedTripSections(
  trip: FullTrip,
  tripItems: Array<TripItem>,
): Array<CuratedTripSection> {
  const { startDay, endDay } = trip
  const sections: Array<CuratedTripSection> = []
  const accountedForItems = new Set<TripItem>()

  if (startDay && endDay) {
    for (let dayIndex = 0; dayIndex < endDay; dayIndex++) {
      const day = startDay + dayIndex

      const sectionHeader = tripItems.find(
        (item): item is NoteItem =>
          item.type === 'NOTE' &&
          !!item.isSectionHeader &&
          !!item.startDay &&
          item.startDay === day,
      )
      const sectionItems = tripItems.filter(
        (item) => item.startDay === day && item !== sectionHeader,
      )

      if (!sectionHeader && sectionItems.length === 0) {
        continue
      }

      sections.push({
        sectionHeader,
        items: sectionItems,
      })

      if (sectionHeader) {
        accountedForItems.add(sectionHeader)
      }
      sectionItems.forEach((item) => accountedForItems.add(item))
    }
  }

  // Put items without dates in their own anonymous section at the end
  const unaccountedForItems = tripItems.filter(
    (item) => !accountedForItems.has(item),
  )
  if (unaccountedForItems.length > 0) {
    sections.push({ items: unaccountedForItems })
  }

  return sections
}
